// import {
//   Box
// } from "@mui/material";
// import { Outlet } from "react-router-dom";
// import SideNav from "../components/sideNav";
// import { useEffect } from "react";
// import Topbar from "../components/Topbar";
// function Layout() {



//   return (
//     <>
//       <Box sx={{ flexGrow: 1  }}>
//         <SideNav />
//         <Box >
//           <Topbar/>
//           <Outlet />
//         </Box>
//       </Box>
//     </>
//   );
// }

// export default Layout;






import { Suspense, useEffect, useLayoutEffect, useRef } from "react";
import { Box } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import SideNav from "../components/sideNav";
import Topbar from "../components/Topbar";
import Loader from "../components/AnimatedLoader";
// Not rendered (see the commented-out <ChatbotUI /> below) — importing it anyway pulled the whole
// chatbot page into the initial bundle. It's still reachable through its own /agent/chatbot route.
// import ChatbotUI from "../view/agent/chatbot";
import { PermissionsProvider } from "../contexts/PermissionsContext";
import ImpersonationBanner from "../components/ImpersonationBanner";
import { startClientLocationRefresh } from "../utils/activityLog";


function Layout() {
  const { pathname } = useLocation();

  // Keeps the Activity Log location fresh while the app is open — silent, only when the user
  // has already granted location permission (the prompt itself is shown at login).
  useEffect(() => startClientLocationRefresh(), []);

  // Publish the height of the chrome above the page (impersonation banner + top bar) as
  // --app-chrome-height, so pages can size themselves to the remaining viewport.
  const mainRef = useRef(null);
  useLayoutEffect(() => {
    const update = () => {
      if (!mainRef.current) return;
      document.documentElement.style.setProperty("--app-chrome-height", `${mainRef.current.offsetTop}px`);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const HIDE_CHATBOT_ROUTES = ["/admin", "/login", "/settings" , "/super-admin"];

  const hideChatbot = HIDE_CHATBOT_ROUTES.some(route =>
    pathname.startsWith(route)
  );

  return (
    <PermissionsProvider>
      <Box sx={{ display: "flex" }}>
        <SideNav />
        <Box sx={{ flexGrow: 1, maxWidth: "100vw", minWidth: 0 }}>
          <ImpersonationBanner />
          <Topbar />
          <Box component="main" ref={mainRef} sx={{ minWidth: 0 }}>
            {/* Pages are code-split (see routes/index.js) — keep the side nav/top bar on screen
                while a page's chunk downloads. */}
            <Suspense fallback={<Loader />}>
              <Outlet />
            </Suspense>
          </Box>
          {/* {!hideChatbot && <ChatbotUI />} */}
        </Box>

      </Box>
    </PermissionsProvider>
  );
}



export default Layout;


